import React, { useEffect } from "react";
import { Box, Button, Container, Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";

export default function PasswordChangeComplete() {
  useEffect(() => {
    document.title = "パスワード変更完了 | じぶん専用IT相談室";
  }, []);
  return (
    <Box className="section bg-dots" component={"section"}>
      <Container className="container">
        <Grid container justifyContent="center">
          <Grid item md={6} style={{ textAlign: "center" }}>
            <SectionHeader
              currentPage={"パスワードの変更が完了いたしました"}
              preHeading={"Password Change"}
            />
            <Typography
              style={{ marginTop: "2rem" }}
              className="mobile-text-left"
            >
              ログイン画面に移動して、新しいパスワードを入力して、ログインください。
            </Typography>

            <Link to={"/login"} style={{ marginTop: "2rem" }}>
              <button
                className="classification-btn"
                style={{ marginTop: "2rem" }}
              >
                ログイン画面へ
              </button>
            </Link>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
